<template>
    <div class="modal fade" :id="modalId" data-bs-backdrop="static" aria-labelledby="describe-segment-modal-title" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header border-bottom-0 pb-0">
                    <h3 class="modal-title" id="describe-segment-modal-title">Generate an Audience</h3>
                    <button type="button" class="btn btn-white close-modal" data-bs-dismiss="modal" aria-label="Close" @click="handleClose">
                        <img class="icon me-0" src="/img/icons/avid-icons/close.svg" alt="">
                    </button>
                </div>
                <div class="modal-body">
                    <p class="mb-3">Describe the audience you want to create.</p>
                    <textarea
                        :id="'describe-segment-context-' + modalId"
                        v-model="userContext"
                        class="form-control describe-segment-context-textarea"
                        rows="4"
                        placeholder="E.g., Donors who gave more than $500 in the last year; Subscribers who haven't opened an email in 6 months..."
                    ></textarea>
                </div>
                <div class="modal-footer pt-1">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="jumpToEditor">Jump to Editor</button>
                    <button type="button" class="btn btn-primary" @click="submit" :disabled="submitting || !userContext.trim()">
                        <span v-if="submitting" class="spinner-border spinner-border-sm me-1" role="status"></span>
                        <img v-else class="icon me-1" src="/img/icons/avid-icons/edna.svg" alt="">
                        Generate
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import { router } from '@inertiajs/vue3';

export default defineComponent({
    name: 'DescribeSegmentModal',
    props: {
        client: {
            type: Object,
            required: true,
        },
        modalId: {
            type: String,
            default: 'describe-segment-modal',
        },
    },
    data() {
        return {
            userContext: '',
            submitting: false,
        };
    },
    methods: {
        submit() {
            if (!this.userContext.trim() || this.submitting) return;
            this.submitting = true;
            window.axios
                .post(`/api/segment-suggestion/${this.client.url}/suggest`, {
                    user_context: this.userContext.trim(),
                })
                .then((response) => {
                    const segmentSuggestionId = response.data.segment_suggestion_id;
                    this.$emit('submitted', { segment_suggestion_id: segmentSuggestionId });
                    this.userContext = '';
                    const modalEl = document.getElementById(this.modalId);
                    if (modalEl && window.bootstrap) {
                        const modal = window.bootstrap.Modal.getInstance(modalEl);
                        if (modal) modal.hide();
                    }
                })
                .catch((error) => {
                    this.$emit('error', error.response?.data?.message || 'Failed to submit. Please try again.');
                })
                .finally(() => {
                    this.submitting = false;
                });
        },
        handleClose() {
            this.userContext = '';
        },
        jumpToEditor() {
            this.handleClose();
            const modalEl = document.getElementById(this.modalId);
            if (modalEl && window.bootstrap) {
                const modal = window.bootstrap.Modal.getInstance(modalEl);
                if (modal) modal.hide();
            }
            router.visit(`/audience/${this.client.url}/new`);
        },
        show() {
            this.userContext = '';
            const modalEl = document.getElementById(this.modalId);
            if (modalEl && window.bootstrap) {
                let modal = window.bootstrap.Modal.getInstance(modalEl);
                if (!modal) modal = new window.bootstrap.Modal(modalEl);
                modal.show();
            }
        },
    },
});
</script>
